import { useNavigate } from 'react-router-dom';
import { articleSummaries } from '@/mocks/categories';

export default function ArticleSummaries() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(slug);
  };

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="text-center mb-14">
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
          Guide
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
          Guide e Approfondimenti SEO
        </h2>
        <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
          Scopri tutto cio che devi sapere su Itaobuy Spreadsheet. Guide complete, recensioni e analisi approfondite per aiutarti a fare le scelte migliori.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articleSummaries.map((article) => (
          <div
            key={article.id}
            className="group bg-background-50 rounded-[24px] overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            onClick={() => handleArticleClick(article.slug)}
          >
            <div className="overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                title={article.title}
                className="w-full aspect-[16/10] object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <span className="inline-block self-start px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-3">
                {article.label}
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 leading-tight group-hover:text-primary-600 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-3 flex-1">
                {article.summary}
              </p>
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 whitespace-nowrap">
                Leggi l&apos;articolo
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}